export default "__VITE_ASSET__DkmCMjGb__"